import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import "./nav.css";

import { auth } from '../../Components/FirebaseComp/firebase'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'; 
import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa';





export const Navbar = ({}) => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleNavLinkClick = () => {
    setIsNavbarOpen(false);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark sticky-top"
      style={{ backgroundColor: "rgb(43, 43, 43)" }}
    >
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img src="/navbar-logo.png" alt="Optica International" height="65" className="navbar-logo" />
        </Link>

        {/* Navbar Toggle Button */}
        <button
          className="navbar-toggler mobile-toggle-button"
          type="button"
          onClick={() => setIsNavbarOpen(!isNavbarOpen)}
          aria-label="Toggle navigation"
        >
          {isNavbarOpen ? <FaTimes size={24} color="#ffd700" /> : <FaBars size={24} color="#ffd700" />}
        </button>

        {/* Navbar Links */}
        <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={handleNavLinkClick}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/aboutus" className="nav-link" onClick={handleNavLinkClick}>
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/membership" className="nav-link" onClick={handleNavLinkClick}>
                Membership
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/registration" className="nav-link" onClick={handleNavLinkClick}>
                Membership Registration
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/services" className="nav-link" onClick={handleNavLinkClick}>
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contactus" className="nav-link" onClick={handleNavLinkClick}>
                Contact Us
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/newsandevents" className="nav-link" onClick={handleNavLinkClick}>
                News & Events
              </Link>
            </li>
            {/* Note: You have duplicate Contact Us - consider removing one */}
          </ul>

          {/* Auth Buttons - Moved outside the ul */}
          <div className="auth-section">
            {!isLoggedIn ? (
              <div className="auth-buttons-container">
                <Link to="/signin">
                  <button className="navbar-btn-login" onClick={handleNavLinkClick}>
                    SIGN IN
                  </button>
                </Link>
                <Link to="/signup">
                  <button className="navbar-btn-login" onClick={handleNavLinkClick}>
                    SIGN UP
                  </button>
                </Link>
              </div>
            ) : (
              <div className="user-menu-container">
                <button className="user-icon" onClick={toggleDropdown}>
                  <FaUserCircle size={24} /> <FaCaretDown size={16} />
                </button>
                {showDropdown && (
                  <ul className="user-dropdown" ref={dropdownRef}>
                    <li>
                      <Link to="/userprofile" onClick={() => setShowDropdown(false)}>
                        <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                      </Link>
                    </li>
                    <li>
                      <Link to="/viewapplication" onClick={() => setShowDropdown(false)}>
                        <FontAwesomeIcon icon={faFile} className="me-2" /> View My All Payments
                      </Link>
                    </li>
                    <li>
                      <Link to="/viewpayment" onClick={() => setShowDropdown(false)}>
                        <FontAwesomeIcon icon={faFile} className="me-2" /> Download My Payment Slips
                      </Link>
                    </li>
                    <li>
                      <button onClick={handleLogout}>
                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};